import { render } from "./TheFooterNav.vue?vue&type=template&id=8ff31c06"
import script from "./TheFooterNav.vue?vue&type=script&lang=js"
export * from "./TheFooterNav.vue?vue&type=script&lang=js"
script.render = render

export default script